module.exports = __webpack_public_path__ + "static/media/lunbo9.ea7c39f3.png";